export enum ETime {
    days = 'days',
    hours = 'hours',
    minutes = 'minutes',
    seconds = 'seconds',
}
